import * as React from "react";
import { connect } from "react-redux";
import DataEntryForm from "../../Forms/DataEntryForm/DataEntryForm";
import {
  IAppRouteLocation,
  IWorkflowItemStep
} from "../../../common/sharedTypes";
import {
  saveDataEntry,
  getFrontSheet,
  loadImage
} from "./redux-objects/actions";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import { Button, Col, Row } from "react-bootstrap";
import { UserInfo } from "../../Login/common/defaults";
import "./dataentry.css";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import * as urls from "../../shared/urls";
import { toast } from "react-toastify";
import { PrintRequest, PrintResponse } from "../../PrintPDF/common/defaults";
import { quickFetch, saveBlob } from "../../PrintPDF/common/utils";
import NotificationTemplateSelector from "../../NotificationTemplate/NotificationTemplateSelector";
import * as optionIds from "../../shared/optionIds";
import Form from "react-bootstrap/Form";
import "./dataentry.css";
import CommentsButton from "../../Comments/CommentsButton";
import CorrespondenceButton from "../../Correspondence/CorrespondenceButton";
import { withRouter } from "react-router-dom";
import * as documentDownloadService from "../../../services/documentDownloadService";
import DriverPdfsButton from "../../shared/DriverPdfsButton/DriverPdfsButton";
import InfoButtonBar from "../common/InfoButtonBar";
import CreateFrontSheetButton from "../../CreateFrontSheetButton/CreateFrontSheetButton";

enum ServiceEndPoints {
  SaveDataEntry = "SaveDataEntry",
  GetPaperPdf = "GetPaperPdf"
}

export interface IDataEntryActionProps {
  saveDataEntry?: (
    url: string,
    itemStep: IWorkflowItemStep,
    data: any,
    moveToNextWorkflow: boolean,
    assignNext: boolean
  ) => Promise<void>;
  loadImage?: (documentId: string, forceNewWindow: boolean) => Promise<void>;
  getFrontSheet?: (crashId: number, forceNewWindow: boolean) => Promise<void>;
  frontSheetData: any[];
}

interface IDataEntryStateProps {
  openWorkflowItemStep?: IWorkflowItemStep;
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
  frontSheet: Uint8Array;
}

interface IDataEntryProps extends IDataEntryActionProps, IDataEntryStateProps { }

interface IDataEntryState {
  data: any;
  formIsValid: boolean;
  isCompleting: boolean;
  spdCheckbox: boolean;
  spdDisabled: boolean;
  workZoneCheckbox: boolean;
  workZoneDisabled: boolean;
  openWorkflowItemStep?: IWorkflowItemStep;
}

export class DataEntry extends React.Component<IDataEntryProps, IDataEntryState> {
  constructor(props: IDataEntryProps) {
    super(props);

    this.state = {
      data: null,
      formIsValid: false,
      isCompleting: false,
      spdCheckbox: false,
      spdDisabled: false,
      workZoneCheckbox: false,
      workZoneDisabled: false,
      openWorkflowItemStep: this.props.openWorkflowItemStep
    };
  }
  private workflowController: string = "Workflow";
  entryForm = null;
  backgroundSave;
  saving = false;

  private crashKey: any;

  private refreshFormValidity = async () => {
    if (!this.entryForm) return false;

    if (this.entryForm.getValidationErrorsAfterFlush) {
      const errors = await this.entryForm.getValidationErrorsAfterFlush();
      const formIsValid = !errors.some((error) => error.type === "error");
      this.setState({ formIsValid });
      return formIsValid;
    }

    if (this.entryForm.isFormValidAfterFlush) {
      const valid = await this.entryForm.isFormValidAfterFlush();
      this.setState({ formIsValid: valid });
      return valid;
    }

    const valid = this.entryForm.isFormValid
      ? this.entryForm.isFormValid()
      : false;
    this.setState({ formIsValid: valid });
    return valid;
  };

  private getSafeFormData = async () => {
    if (!this.entryForm) return null;

    if (this.entryForm.getLatestFormData) {
      return await this.entryForm.getLatestFormData();
    }

    return this.entryForm.getFormData();
  };

  loadWorkflowItemStep = () => {
    if (!this.state.openWorkflowItemStep) {
      this.props.history?.push('/DataEntryQueue');
      return;
    }

    this.getDataEntryJsonData(this.state.openWorkflowItemStep);
    this.initializeCheckboxes(this.state.openWorkflowItemStep);

    const keywords = this.state.openWorkflowItemStep?.workflowItem?.report?.keywords;
    const documentId = keywords?.documentId;
    if (documentId) {
      const reportId = this.state.openWorkflowItemStep?.workflowItem?.reportId;
      if (reportId && reportId != 0) {
        this.viewAllDocuments(reportId);
      }
    } else {
      console.log("no documentId?", this.state.openWorkflowItemStep);
    }

    if (documentId) {
      // BKC: commented this out so that the front sheet was not being called when opening the data entry
      // this.handleOpenPdf();
    }
  };

  initializeCheckboxes = (openWorkflowItemStep: IWorkflowItemStep) => {
    const keywords: any = openWorkflowItemStep?.workflowItem?.report?.keywords || {};
    const hasStatePropertyDamage =
      typeof keywords.propertyDamageIndicator === "string"
        ? keywords.propertyDamageIndicator.toLocaleLowerCase() == "yes"
        : false;
    const isWorkzone =
      typeof keywords.workZoneIndicator === "string"
        ? keywords.workZoneIndicator.toLocaleLowerCase() == "yes"
        : false;
    this.setState({
      spdCheckbox: !!hasStatePropertyDamage,
      spdDisabled: !!hasStatePropertyDamage,
      workZoneCheckbox: !!isWorkzone,
      workZoneDisabled: !!isWorkzone
    });
  };

  componentDidMount() {
    if (!this.backgroundSave) {
      this.backgroundSave = setInterval(() => {
        if (this.state.openWorkflowItemStep && !this.saving)
          this.handleComplete(null, false, false, false);
      }, 30000);
    }

    this.loadWorkflowItemStep();
  }

  componentDidUpdate(prevProps: IDataEntryProps) {
    const nextOpenWorkflowItemStep = this.props.openWorkflowItemStep;
    if (
      nextOpenWorkflowItemStep &&
      prevProps.openWorkflowItemStep !== nextOpenWorkflowItemStep &&
      this.state.openWorkflowItemStep !== nextOpenWorkflowItemStep
    ) {
      this.setState({ openWorkflowItemStep: nextOpenWorkflowItemStep }, () => {
        this.loadWorkflowItemStep();
      });
    }
  }

  viewAllDocuments = (reportId: number) => {
    const url = `/DocumentViewer?r=${reportId}&dbToSearch=${"private"}`;
    window.open(url, "_blank", "width=1300,height=900");
  };

  setSpdCheckbox = () => {
    this.setState({ spdCheckbox: !this.state.spdCheckbox });
    this.setStatePropertyDamage();
  };

  setStatePropertyDamage = () => {
    if (!this.state.openWorkflowItemStep?.workflowItem?.report?.keywords) {
      return;
    }

    Api.post(
      urls.SAVE_STATE_PROPERTY_DAMAGE +
      "?workflowItemStepId=" +
      this.state.openWorkflowItemStep.id,
      {
        ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
        propertyDamageIndicator: this.state.spdCheckbox
      }
    ).then((response: ApiResponse<any>) => {
      if (response.ok) {
      }
    });
  };

  setWorkZoneCheckbox = () => {
    this.setState({
      workZoneCheckbox: !this.state.workZoneCheckbox,
      workZoneDisabled: true
    });
    this.setWorkZone();
  };

  setWorkZone = () => {
    if (!this.state.openWorkflowItemStep?.workflowItem?.report?.keywords) {
      return;
    }

    Api.post(urls.SAVE_WORK_ZONE_INDICATOR, {
      ...this.state.openWorkflowItemStep.workflowItem.report.keywords,
      workZoneIndicator: this.state.workZoneCheckbox
    }).then((response: ApiResponse<any>) => {
      if (response.ok) {
      }
    });
  };

  sendToManagementQueue = () => {
    try {
      this.handleComplete(null, false, false, false, true);
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.state.openWorkflowItemStep.id
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let location: IAppRouteLocation = {
            pathname: "/DataEntryQueue"
          };
          this.props.history.push(location);
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  loadImage = (forceNewWindow: boolean) => {
    return;
  };

  getFrontSheet = (forceNewWindow: boolean) => {
    return;
  };

  getDataEntryJsonData = (openWorkflowItemStep: IWorkflowItemStep) => {
    if (!openWorkflowItemStep) {
      this.setState({ data: {} });
      return;
    }

    let id;
    if (openWorkflowItemStep != null) {
      id = { id: openWorkflowItemStep.workflowItemId.toString() };
      this.crashKey =
        openWorkflowItemStep.workflowItem?.report?.keywords?.crashKey
          ? openWorkflowItemStep.workflowItem.report.keywords.crashKey.toString()
          : "0";
    } else {
      id = "0";
      this.crashKey = "0";
    }

    if (this.crashKey == null) {
      this.crashKey = "No Crash Key Available";
    }

    Api.post(urls.GET_REPORT_VALIDATION_JSON, JSON.stringify(id)).then(
      (response: ApiResponse<any>) => {
        if (response.ok)
          this.setState({
            data: response.data || {}
          });
        else {
          console.error(response.originalError);
          this.setState({ data: {} });
        }
        return response.data;
      }
    );
  };

  async handleComplete(
    event: React.MouseEvent<HTMLElement>,
    assignNext: boolean,
    moveToNextWorkflow: boolean,
    continueNavigation: boolean = true,
    manualSave: boolean = false
  ): Promise<void> {
    if (!this.state.openWorkflowItemStep || !this.entryForm) {
      return;
    }

    // Prevent overlapping manual/background saves that can lead to mixed toasts.
    if (this.saving) {
      return;
    }

    if (moveToNextWorkflow) {
      this.setState({ isCompleting: true });
      const isValidNow = await this.refreshFormValidity();
      if (!isValidNow) {
        toast.error("Please correct required fields before completing.");
        this.setState({ isCompleting: false });
        return;
      }
    }

    var formData = moveToNextWorkflow
      ? await this.getSafeFormData()
      : this.entryForm.getFormData();
    if (!formData) {
      this.setState({ isCompleting: false });
      return;
    }

    //console.log('form data: ', formData);
    //console.log('Driver Birth Date: ', formData.data.Units[0].DriverDateOfBirth);
    //console.log('Occupant 1 (driver) Birthdate:', formData.data.Units[0].AllOccupants[0].OccupantDateOfBirth);
    if (formData.data?.DateOfCrash?.trim() == "") {
      this.setState({ isCompleting: false });
      return;
    }

    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.SaveDataEntry
    );
    this.saving = true;

    return new Promise<void>((resolve, reject) => {
      this.props
        .saveDataEntry(
          uri,
          this.state.openWorkflowItemStep,
          formData,
          moveToNextWorkflow,
          assignNext
        )
        .then(() => {
          this.saving = false;
          if (continueNavigation) {
            toast.success("Completed");
            if (assignNext) {
              this.setState(
                {
                  openWorkflowItemStep: this.props.openWorkflowItemStep
                },
                () => {
                  this.loadWorkflowItemStep();
                }
              );
            } else this.props.history.push("/DataEntryQueue");
          } else {
            if (manualSave) {
              toast.success("Saved");
            }
          }
        })
        .catch((e) => {
          // Keep background autosave failures silent to avoid showing an error
          // alongside a successful user-initiated save toast.
          if (continueNavigation || manualSave) {
            toast.error("Error saving or completing");
          }
          console.log(e);
          return;
        })
        .finally(() => {
          this.saving = false;
          this.setState({ isCompleting: false });
          resolve();
        });
    });
  }

  componentWillUnmount() {
    if (this.backgroundSave) {
      clearInterval(this.backgroundSave);
      this.backgroundSave = null;
    }
  }

  handleOpenPdf = () => {
    const documentId = this.state.openWorkflowItemStep?.workflowItem?.report?.keywords?.documentId;
    if (!documentId) {
      return;
    }

    documentDownloadService
      .openOnBaseImage(null, documentId)
      .then();
  };

  checkIsFormValid = (submission: any, formIsValid?: boolean) => {
    if (typeof formIsValid === 'boolean') {
      this.setState({ formIsValid });
      return;
    }

    if (this.entryForm && typeof this.entryForm.isFormValid === 'function') {
      this.setState({ formIsValid: this.entryForm.isFormValid() });
    }
  };

  public render() {
    const openWorkflowItemStep = this.state.openWorkflowItemStep;
    const report = openWorkflowItemStep?.workflowItem?.report;
    const reportId = openWorkflowItemStep?.workflowItem?.reportId;
    const formId = openWorkflowItemStep?.workflowStep?.formIoFormId;

    const allButtons = (
      <React.Fragment>
        <div className="completeAndStartNextButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, true, true)}
            disabled={!this.state.formIsValid || this.state.isCompleting}
          >
            Complete and Start Next Report
          </Button>
        </div>
        <div className="completeButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, false, true)}
            disabled={!this.state.formIsValid || this.state.isCompleting}
          >
            Complete
          </Button>
        </div>
        <div className="saveReportButton">
          <Button
            variant="success"
            size="sm"
            onClick={(e) => this.handleComplete(e, false, false, false, true)}
          >
            Save Report
          </Button>
        </div>
      </React.Fragment>
    );

    if (!openWorkflowItemStep) {
      return <strong>Loading Form...</strong>;
    }

    return (
      <div>
        <Row>
          <Col>
            <div className="workZoneCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Work Zone"
                  disabled={this.state.workZoneDisabled}
                  checked={this.state.workZoneCheckbox}
                  onChange={this.setWorkZoneCheckbox}
                />
              </Form.Group>
            </div>
            <div className="spdCheckbox">
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="State Property Damage"
                  checked={this.state.spdCheckbox}
                  onChange={this.setSpdCheckbox}
                />
              </Form.Group>
            </div>
          </Col>
          <Col className="justify-content-end">
            {reportId != null && (
              <NotificationTemplateSelector
                optionId={optionIds.dataEntryOptionId}
                reportId={reportId}
              />
            )}
          </Col>
          <Col xs={2} className="justify-content-end">
            {reportId != null && (
              <>
                <CommentsButton
                  reportId={reportId}
                  className="pull-right"
                  placement="left"
                />
                <CorrespondenceButton
                  reportId={reportId}
                  className="pull-right mr-10"
                />
              </>
            )}
          </Col>
        </Row>
        {report && (
          <InfoButtonBar
            report={report}
            handleOpenPdf={this.handleOpenPdf}
            sendToManagementQueue={this.sendToManagementQueue}
            createFrontSheetButton={
              <CreateFrontSheetButton
                reportId={reportId}
                onBeforeClick={() =>
                  this.handleComplete(null, false, false, false, true)
                }
                className="openReportPdfButton"
              />
            }
          />
        )}
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        {this.state.data && Object.keys(this.state.data).length > 0 && formId && (
          <DataEntryForm
            key={openWorkflowItemStep.id}
            data={this.state.data}
            injectToSidebar={allButtons}
            ref={(el) => (this.entryForm = el)}
            onChange={this.checkIsFormValid}
            formId={formId}
          />
        )}
        {!this.state.data && <strong>Loading Form...</strong>}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    openWorkflowItemStep: state.DataEntryQueue.openWorkflowItemStep,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  saveDataEntry,
  loadImage,
  getFrontSheet
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataEntry)
);
